import { useQuery } from "@tanstack/react-query";
import { SystemSearchVersion } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const fetchSearchVersionCheck = ({ queryKey }) => {
  const [
    ,
    /* queryName */
    { distribution, version }
  ] = queryKey;
  return defaultOnError(
    SystemSearchVersion.satisfiesVersion(distribution, version || void 0),
    "Could not fetch override data"
  );
};
const useSearchVersionCheck = (distribution, version) => {
  const MAIN_KEY = "SearchVersionQuery";
  const queryKey = [MAIN_KEY, { distribution, version: version != null ? version : null }];
  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: (args) => defaultOnError(fetchSearchVersionCheck(args), "Could not fetch override data")
  });
  return {
    data,
    isLoading,
    error
  };
};
export default useSearchVersionCheck;
